import { useState } from "react";
import { fetchResponseAdapter } from "../../../../../adapters/fetchAdapter";
import useCallApiAndLoad from "../../../../../hooks/useCallApiAndLoad";
import { getBookedUsers } from "../../../services/devsServices";
import { useDispatch, useSelector } from "react-redux";
import { unsetAuth } from "../../../../../helpers/authHelper";
import { getAuthToken } from "../../../../../helpers/authHelper";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../../../../redux/store";
import { logoutAction } from "../../../../../redux/features/auth";

export const useDetailProjectBookedUsers = () => {
    const user = useSelector((store: AppStore) => store.auth);
    const token = require("../../../../../helpers/authHelper").getAuthToken(user);
    const { country } = useSelector((store: AppStore) => store.country);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [bookedUsers, setBookedUsers] = useState([]);
    const [bookedUsersLoading, setBookedUsersLoading] = useState(false);
    const { callEndpoint } = useCallApiAndLoad();

    const getUsersBooked = async (idModel: string, idProject: string) => {
        if (bookedUsers.length > 0) return; // Si ya hay datos, no consultar
        setBookedUsersLoading(true);
        try {
            const { status, data } = await callEndpoint(getBookedUsers(token, idProject, idModel));
            if (status === 401) {
                setBookedUsersLoading(false);
                dispatch(logoutAction({}));
                unsetAuth();
                navigate(`/app/${country}/auth/desarrolladoras/login`);
            }
            console.log({ status })
            if (status === 200) {
                const response = fetchResponseAdapter(data);
                setBookedUsersLoading(false);


                setBookedUsers(response?.data);
            }
        } catch (error) {
            setBookedUsersLoading(false);
        }
    };

    return { bookedUsers, bookedUsersLoading, getUsersBooked };
};
